<template>
  <div>
    <PCMenu :memberSystem="company" />
    <div class="m-auto w1200 newslistpage m-t-20">
      <ul class="flex">
        <li class="left m-r-20">
          <dl class=" m-l-20 m-r-20">
            <dt>公告信息</dt>
            <dd v-for="(news, index) in newsList.dataList" :key="index" @click="showNews(news.id)">{{news.title}}
              <!--<span>05-08</span>-->
            </dd>
            <div id="laypage"></div>
          </dl>
        </li>
        <li class="right m-l-20">
          <dl class="newslist m-l-20 m-r-20">
            <dt>最新公告</dt>
            <dd v-for="(news, index) in topNewsList" :key="index" @click="showNews(news.id)">{{news.title}}
              <!--<span>05-08</span>-->
            </dd>
          </dl>
        </li>
      </ul>
    </div>
<!--    <PCCopyright />-->
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import { Get_News_List } from "@/api/index";
import {
  Col,
  Row,
  Icon,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  Popup,
  SubmitBar,
  Dialog,
} from "vant";

export default {
  name: "NewsList",
  components: {
    PCMenu,
    PCCopyright,
    [Col.name]: Col,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [SubmitBar.name]: SubmitBar,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      newsList: [],
      topNewsList: [],
      company:{}
    };
  },
  methods: {
      showNews: function (id) {
      var that = this;
      layui.use(["layer", "form"], function () {
        var layer = layui.layer,
          form = layui.form;
        var title = that.newsList.dataList.find((m) => m.id == id).title;
        layer.open({
          type: 1,
          title: "公告",
          skin: "layui-layer-rim", //加上边框
          area: ["420px", "240px"], //宽高
          content: '<div style="padding:10px">' + title + "</div>",
        });
      });
    },
  },
  mounted() {
    const _this = this;

    layui.use(["jquery", "layer", "laypage"], async function () {
      var layer = layui.layer,
        $ = layui.jquery,
        laypage = layui.laypage;
      _this.form = layui.form;

      let pageSize = 10;
      let page=1;
      _this.newsList = [];//await Get_News_List({ page: page, pageSize: pageSize });
      _this.topNewsList = _this.newsList.slice(0, 5);
      laypage.render({
        elem: "laypage",
        limit: pageSize,
        count: _this.newsList.totalCount,
        curr: location.hash.replace("#!page=", ""),
        hash: "page",
        jump: async function (obj, first) {
          console.log(obj.curr); //得到当前页，以便向服务端请求对应页的数据。
          console.log(obj.limit); //得到每页显示的条数

          if (!first) {
            _this.newsList = [];//await Get_News_List({page: obj.curr,pageSize: obj.limit,});
          }
        },
      });
    });
    this.global.getMemberSystem().then((memberSystem) => {
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
      }
    });
  },
};
</script>
